<div class="fallback-address">
  <div class="fallback-address__input-container">
    <pdq-input
      style="width: 100%"
      [label]="label"
      [autocompleteMode]="true"
      [autocompleteRef]="autocompleteRef"
      showBrowserAutocomplete="off"
      [control]="fallbackAddressTextControl"
      [value]="fallbackAddressTextControl.value"
      autoCompleteWidth="360"
      placeholder="Start typing..."
      [displayReset]="!!fallbackAddressTextControl.value"
      (onReset)="clearFallbackAddress()"></pdq-input>
    <address-autocomplete
      [query]="fallbackAddressTextControl.value"
      [control]="fallbackAddressTextControl"
      (autoCompleteInit)="initAutoCompleteRef($event)"
      (autoCompleteSelected)="onAutoCompleteSelected($event)">
    </address-autocomplete>
  </div>
  @if (fallbackAddressTextControl.invalid) {
    <p class="fallback-address__error">The address must be selected from one of the autocomplete options</p>
  }
</div>
